module.exports = __webpack_public_path__ + "img/awards8.cc9200a7.svg";